// extracted by mini-css-extract-plugin
export var dropdownIcon = "_q2-6";
export var imgContainer = "_q2-3";
export var menuIcon = "_q2-5";
export var pillWrapper = "_q2-2";
export var pillsContainer = "_q2-1";
export var subscriptionCard = "_q2-0";
export var subscriptionLogo = "_q2-4";